/**
 * personalised-ab-router.js
 *
 * Coupled A/B router for review + library page experiment.
 * Uses customer age (from quiz/recommendation) as a routing proxy:
 *   - Odd age  → V1 review + V1 library
 *   - Even age → V2 review + V2 library
 *   - Missing/invalid age → V2 review + V2 library
 *   - Feature flag OFF → V1 (current behaviour)
 *
 * Must load synchronously immediately after personalised-config.js.
 *
 * Idempotent — safe to load more than once (guards against double-init).
 */
(function() {
  window.personalised = window.personalised || {};

  // Guard: do not re-initialise if already loaded.
  if (window.personalised.abRouter) return;

  var config = window.personalised.config;
  if (!config || !config.routes) return;

  var reviewV1 = config.routes.reviewV1 || '/pages/personalised-review';
  var reviewV2 = config.routes.reviewV2 || '/pages/review-pack';
  var libraryV1 = config.routes.libraryV1 || '/pages/personalised-library';
  var libraryV2 = config.routes.libraryV2 || '/pages/library-v2';

  function getAssignment() {
    if (!config.features || !config.features.abTestReviewPage) {
      return 'v1';
    }

    try {
      var age = parseInt(localStorage.getItem('vitable_age'), 10);

      if (!age || isNaN(age)) {
        return 'v2';
      }

      return (age % 2 === 0) ? 'v2' : 'v1';
    } catch (e) {
      return 'v2';
    }
  }

  function getReviewUrl() {
    return getAssignment() === 'v2' ? reviewV2 : reviewV1;
  }

  function getLibraryUrl() {
    return getAssignment() === 'v2' ? libraryV2 : libraryV1;
  }

  /**
   * Idempotent link rewriter — updates all elements with
   * data-personalised-review-link or data-personalised-library-link,
   * plus any <a> whose href points to V1 URLs, to the A/B-assigned URL.
   * Safe to call multiple times.
   */
  function rewritePersonalisedLinks() {
    var reviewUrl = getReviewUrl();
    var libraryUrl = getLibraryUrl();

    if (reviewUrl) {
      document.querySelectorAll('a[data-personalised-review-link]').forEach(function(link) {
        link.href = reviewUrl;
      });
      document.querySelectorAll('a[href$="' + reviewV1 + '"]').forEach(function(link) {
        link.href = reviewUrl;
      });
    }

    if (libraryUrl) {
      document.querySelectorAll('a[data-personalised-library-link]').forEach(function(link) {
        link.href = libraryUrl;
      });
      document.querySelectorAll('a[href$="' + libraryV1 + '"]').forEach(function(link) {
        link.href = libraryUrl;
      });
    }
  }

  config.routes.review = getReviewUrl();
  config.routes.library = getLibraryUrl();

  window.personalised.abRouter = {
    getAssignment: getAssignment,
    getReviewUrl: getReviewUrl,
    getLibraryUrl: getLibraryUrl,
    rewritePersonalisedLinks: rewritePersonalisedLinks
  };

  // Rewrite on initial page load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewritePersonalisedLinks);
  } else {
    rewritePersonalisedLinks();
  }

  // Rewrite after cart drawer/cart content is dynamically re-rendered.
  document.addEventListener('cart:updated', rewritePersonalisedLinks);
})();
